import {
    saveUserSettings,
    userSettings
} from "@/globals/userSettings";
import { LANGUAGES } from "./Languages";
import translateWidget from "@/views/menu/translateWidget";
import { $menu } from "@/views/menu/menu";
import { pluginConfig } from "@/globals/pluginConfig";

export function changeLanguage(newLang, $menu) {
    newLang = String(newLang || "").toLowerCase();
    if (!LANGUAGES.some(lang => lang.code === newLang)) {
        newLang = pluginConfig.language.default;
    }

    if (userSettings.lang !== newLang) {
        userSettings.lang = newLang;

        const $lang = $menu.querySelector("#cya11y-language");
        if ($lang) {
            $lang.value = newLang;
        }

        translateWidget($menu);
        saveUserSettings();
    }
}